import { createFetch } from "@vueuse/core";
import { computed } from "vue";
import { API_BASE } from "@/config/appConfig";

export default (owner) => {
  const fetch = createFetch({
    baseUrl: API_BASE,
    options: {
      async beforeFetch(req) {
        req.options.headers['Tgb-Owner'] = owner;
      },
      async onFetchError(payload) {
        console.log("Shoppable fetch error", payload);
        return payload;
      },
    },
    fetchOptions: {
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  });

  const getProducts = (query, opts) => {
    const queryString = computed(() => new URLSearchParams(query.value).toString());
    const url = computed(() => `public/products?${queryString.value}`);
    return fetch(url, opts).get().json();
  };

  const getProduct = (id, opts) => {
    const url = computed(() => `public/products/${id.value}`);
    return fetch(url, opts).get().json();
  };

  return {
    getProducts,
    getProduct,
  };
};
